/**
 * @generated SignedSource<<30b68df9830f670d2b6267d340c7730a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appSubscriptionCheck$data = {
  readonly isAdminUser: boolean;
  readonly subscription: {
    readonly isCancelled: boolean;
  } | null;
  readonly " $fragmentType": "appSubscriptionCheck";
};
export type appSubscriptionCheck$key = {
  readonly " $data"?: appSubscriptionCheck$data;
  readonly " $fragmentSpreads": FragmentRefs<"appSubscriptionCheck">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appSubscriptionCheck",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAdminUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ZakekeSubscription",
      "kind": "LinkedField",
      "name": "subscription",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCancelled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "f1a557369a61fa718218c344ff6acd73";

export default node;
